import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateScatterPositions = (
  starsData: StarData[],
  config: GalaxyConfig
): StarPosition[] => {
  const scaleX = 0.7;
  const scaleZ = 0.7;
  const maxExtent = config.galaxyRadius * 0.9;

  return starsData.map((star) => {
    const roi = Math.max(-100, Math.min(100, star.roi));
    const fRoi = Math.max(-100, Math.min(100, star.f_roi));

    const rawX = roi * scaleX;
    const rawZ = fRoi * scaleZ;

    return {
      x: Math.max(-maxExtent, Math.min(maxExtent, rawX)) + (Math.random() - 0.5) * 2,
      y: (Math.random() - 0.5) * 1.5,
      z: Math.max(-maxExtent, Math.min(maxExtent, rawZ)) + (Math.random() - 0.5) * 2,
    };
  });
};
